import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  private buildHeaders(
    contentType: string = '',
    customHeaders: { [key: string]: string } = {} // Custom headers as an object
  ): HttpHeaders {
    let headers = new HttpHeaders();

    // If contentType is provided, set it in the headers
    if (contentType) {
      headers = headers.set('Content-Type', contentType);
    }

    // Add custom headers
    for (const key in customHeaders) {
      if (customHeaders.hasOwnProperty(key)) {
        headers = headers.set(key, customHeaders[key]);
      }
    }

    return headers;
  }

  getAbsoulteUrl(
    url: string,
    params: HttpParams = new HttpParams()
  ): Observable<any> {
    return this.http.get(url, { params }).pipe(catchError(this.formatErrors));
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    const url = `${environment.api_url}${path}`;
    return this.http.get(url, { params }).pipe(catchError(this.formatErrors));
  }

  put(
    path: string,
    body: any = {},
    contentType: string = '',
    customHeaders: { [key: string]: string } = {}
  ): Observable<any> {
    const url = `${environment.api_url}${path}`;
    const headers = this.buildHeaders(contentType, customHeaders);

    return this.http
      .put(url, body, { headers })
      .pipe(catchError(this.formatErrors));
  }

  post(
    path: string,
    body: any = {},
    contentType: string = 'application/json',
    customHeaders: { [key: string]: string } = {}
  ): Observable<any> {
    const url = `${environment.api_url}${path}`;
    const headers = this.buildHeaders(contentType, customHeaders);

    return this.http
      .post(url, body, { headers })
      .pipe(catchError(this.formatErrors));
  }

  delete(path: any, bodyObj: any): Observable<any> {
    const url = `${environment.api_url}${path}`;
    const httpOptions = {
      body: bodyObj,
    };
    return this.http
      .request('delete', url, httpOptions)
      .pipe(catchError(this.formatErrors));
  }
}
